module.exports = __webpack_public_path__ + "img/efind.a852a879.png";